/* Copyright 2014-2020 The MathWorks, Inc. */

define([
    "./UIBuilder",
    "mw-actiondataservice/ActionDataService",
    "MW/toolstrip/constants/QABAuthoringModeConstants"
], function (UIBuilder, ActionDataService, QABAuthoringModeConstants) {
    var _instances = {}, UIBuilderFactory, DEFAULT_CHANNEL, ACTION_CHANNEL_SUFFIX;

    DEFAULT_CHANNEL =  "/DefaultUIBuilderPeerModelChannel";
    ACTION_CHANNEL_SUFFIX = "_Action";

    /**
     * <code>UIBuilderFactory</code> provides methods to create, access and destroy instances of UIBuilder.<br>
     * Each UIBuilder corresponds to a particular Peer Model Channel.
     *
     * @exports MW/uiframework/UIBuilderFactory
     *
     * @module
     */
    UIBuilderFactory = {
        /**
         * This method returns the instance corresponding to the supplied channel if it already exists otherwise it
         * creates one.
         * @param {object} args This object can be provided the following properties:
         * @param {string} args.channel The peer model channel to use for the UIBuilder. If not provided, a default
         * channel is used.
         * @param {boolean} args.isMATLABDriven If set to true then the root nodes are expected to be created by MATLAB.
         * @param {object} args.actionService An instance of the action data service to use, if not provided a default
         * one is created and used by UIBuilder.
         * @param {object} args.enableQABCustomization A boolean that determines whether the QAB
         * should be customizable, defaults to false
         * @param {String} args.qabAuthoringMode A string that determines the QAB authoring mode. The value can be
         * passed using "MW/toolstrip/constants/QABAuthoringModeConstants" and can be one of the 2 modes: default and manual.
         * In the default mode, QA Group is created automatically for a Tab Group and items in the QAB that belong
         * to a contextual tab are shown/hidden based on the correponding tab group being added/removed. This
         * behavior is turned off in the manual mode where users will get to create their own QA Groups and have
         * more control on the state of the widgets in the QAB.
         * @returns {object} An instance of UIBuilder corresponding to the given channel or the default instance if no
         * channel was given.
         */
        getInstance: function (args) {
            args = args || {};

            args.channel = args.channel || DEFAULT_CHANNEL;
            args.enableQABCustomization = args.enableQABCustomization || false;
            args.lazyLoading = args.lazyLoading || false;
            args.qabAuthoringMode = args.qabAuthoringMode || QABAuthoringModeConstants.DEFAULT;
            // Adding a temporary flag until the swtich to viewmodel is complete
            args._openWithViewModel = args._openWithViewModel || false;

            if (!_instances[args.channel]) {
                args.isMATLABDriven = !!args.isMATLABDriven;
                args.actionService = args.actionService || new ActionDataService({
                    nameSpace: args.channel + ACTION_CHANNEL_SUFFIX,
                    mode: args.isMATLABDriven ? "ActAsClient" : "StandAlone"
                });
                _instances[args.channel] = new UIBuilder(args);
            }

            return _instances[args.channel];
        },

        /**
         * Cleans up the UIBuilder instance corresponding to the given channel. If no channel is provided, the default
         * instance is cleaned up.
         * @param {string} channel The channel whose corresponding instance should be cleaned up.
         */
        destroyInstance: function (channel) {
            channel = channel || DEFAULT_CHANNEL;
            if (_instances[channel]) {
                _instances[channel].cleanup();
                delete _instances[channel];
            }
        }
    };

    return UIBuilderFactory;
});